const videoRouter = [
  {
    path: '/video',
    name: 'VideoIndex',
    component: () => import('@/views/video/index')
  },
  {
    path: '/video/:id(\\d+)',
    name: 'VideoDetail',
    component: () => import('@/views/video/detail')
  }
]

export default videoRouter



// WEBPACK FOOTER //
// ./src/router/modules/video.js